import CryptoJS from "crypto-js";
const key = 'iNl8rzEB0gIDjqwO',
secretKey = CryptoJS.enc.Utf8.parse(key)

const encryption = (word) => {
  const str = typeof (word) === 'string' ? word:JSON.stringify(word)
    const Text = CryptoJS.AES.encrypt(str, secretKey, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
    });
    return Text.toString()
}
const decrypt = (word) => {
  if (word == null || word=="") {
      return ""
    }
  const decryptedText = CryptoJS.AES.decrypt(word, secretKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
  })
    return decryptedText.toString(CryptoJS.enc.Utf8)
}
export {
  encryption,
  decrypt
}

